import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCT_REQUEST,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAILURE,
  UPDATE_PRODUCTS_REQUEST,
  UPDATE_PRODUCTS_FAILURE,
  UPDATE_PRODUCTS_SUCCESS,
  DELETE_PRODUCTS_REQUEST,
  DELETE_PRODUCTS_FAILURE,
  DELETE_PRODUCTS_SUCCESS,
  OPEN_EDIT_PAGE_PRODUCT,
  CLEAR_PRODUCT_ERRORS,    // Nouvelles imports
  CLEAR_PRODUCT_SUCCESS,
} from './actionTypes';

const initialState = {
  products: [],
  product: null,
  loadingProduct: false,
  errorProduct: null,
  productAdded: null,
  editItemId: null, // Ajouté car utilisé dans le reducer
};

const Products = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        loadingProduct: true,
        errorProduct: null,
        productAdded: false
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loadingProduct: false,
        products: action.payload,
      };
    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        loadingProduct: false,
        errorProduct: action.payload,
      };
    case FETCH_PRODUCT_REQUEST:
      return {
        ...state,
        loadingProduct: true,
        errorProduct: null,
        productAdded: false
      };
    case FETCH_PRODUCT_SUCCESS:
      return {
        ...state,
        loadingProduct: false,
        product: action.payload.data,
      };
    case FETCH_PRODUCT_FAILURE:
      return {
        ...state,
        loadingProduct: false,
        errorProduct: action.payload,
      };
    case UPDATE_PRODUCTS_REQUEST:
      return {
        ...state,
        loadingProduct: true,
        errorProduct: null,
        productAdded: false
      };
    case UPDATE_PRODUCTS_SUCCESS:
      return {
        ...state,
        loadingProduct: false,
        product: null,
        productAdded: true
      };
    case UPDATE_PRODUCTS_FAILURE:
      return {
        ...state,
        loadingProduct: false,
        errorProduct: action.payload,
      };
    case DELETE_PRODUCTS_REQUEST:
      return {
        ...state,
        loadingProduct: true,
        errorProduct: null,
        productAdded: false
      };
    case DELETE_PRODUCTS_SUCCESS:
      return {
        ...state,
        productAdded: true,
        loadingProduct: false,
        products: state.products.filter(product => product.id !== action.payload),
      };
    case DELETE_PRODUCTS_FAILURE:
      return {
        ...state,
        loadingProduct: false,
        errorProduct: action.payload,
      };
    case OPEN_EDIT_PAGE_PRODUCT:
        return {
          ...state,
          editItemId: action.payload.id,
        };
    case CLEAR_PRODUCT_ERRORS:
      return {
        ...state,
        errorProduct: null,
      };
    case CLEAR_PRODUCT_SUCCESS:
      return {
        ...state,
        productAdded: null,
      };
      
    default:
      return state;
  }
};

export default Products;